<template>
  <div>
    <div class="ms-4 py-1 m-2 condition-border">
      <div v-if="!isLoading">
        <MultiSelectComponent
          id="mentorMagicSelect"
          v-model="select"
          class="mb-2 my-1"
          :max-selected-options="1"
          :label="trans('subscription.classification_config.selectors.mentor.select')"
          :type="'employee'"
          track-by="id"
          :include="{ 'program_id': programId }"
          @input="changePropertyValueMultiSelect"
        />

        <p class="pt-4">
          {{ trans('subscription.classification_config.selectors.mentor.date_explanation') }}
        </p>

        <date-picker-component
          id="date"
          v-model="date"
          :label="trans('core.date')"
          @input="changePropertyValueDate"
        />
      </div>
      <Loader
        v-else
        class="pb-3"
      />
    </div>
  </div>
</template>

<script>
import DatePickerComponent from '@/employees/components/FormComponents/DatePickerComponent.vue'
import MultiSelectComponent from '@/employees/components/FormComponents/MultiSelectComponent'
import selectorMixin from '@/employees/components/Selector/utilities/mixins/selectorMixin'
import { SELECTOR_PROPERTY } from '@/constants'
import { mapState } from 'vuex'

export default {
  name: 'SelectorMentor',
  components: {
    MultiSelectComponent,
    DatePickerComponent,
  },
  mixins: [selectorMixin],
  inject: ['selectorContext', 'programId'],
  props: {
    selectorReference: {
      required: true,
      type: String,
    },
    selector: {
      required: true,
      type: Object,
    },
  },
  data () {
    return {
      select: [],
      date: null,
      selectorPropertyConstant: SELECTOR_PROPERTY,
      isLoading: false,
    }
  },
  computed: {
    ...mapState({
      missingId (state) {
        if (!state.employees.employees.hasOwnProperty(this.selector.mentor) && this.selector.mentor) {
          return this.selector.mentor
        }
        return null
      },
      employees (state) {
        if (!state.employees.employees.hasOwnProperty(this.selector.mentor)) {
          return []
        }
        const result = state.employees.employees[this.selector.mentor]
        return [{
          id: this.selector.mentor,
          name: result.name,
        }]
      },
    }),
  },
  created () {
    this.$store.dispatch('getEmployees', { queryParams: {} })
  },
  mounted () {
    if (this.selector.mentor && this.missingId) {
      this.isLoading = true
      this.$store.dispatch('getEmployees', {
        queryParams: {
          filter: {
            id: this.missingId,
          },
        },
      }).then(() => {
        this.select = this.employees
        this.date = this.selector.date ?? null
      }).finally(() => {
        this.isLoading = false
      })
    } else {
      this.select = this.employees
      this.date = this.selector.date ?? null
    }
  },
  methods: {
    changePropertyValueMultiSelect (newValue) {
      if (newValue.length > 0) {
        this.selectorPropertyValueAdd(this.selectorReference, this.selectorPropertyConstant.mentor, newValue[0].id)
      } else {
        this.selectorPropertyValueAdd(this.selectorReference, this.selectorPropertyConstant.mentor, null)
      }
    },
    changePropertyValueDate (newValue) {
      if (newValue) {
        this.selectorPropertyValueAdd(this.selectorReference, this.selectorPropertyConstant.date, newValue)
      } else {
        this.selectorPropertyValueAdd(this.selectorReference, this.selectorPropertyConstant.date, null)
      }
    },
  },
}
</script>

<style scoped>
/deep/
.form-control {
  width: auto;
}
/deep/
.col-sm-2 {
  float: none;
}
/deep/
.col-sm-10 {
  float: none;
}
</style>
